
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsDocTypeDialog extends Serenity.EntityDialog<CsDocTypeRow, any> {
        protected getFormKey() { return CsDocTypeForm.formKey; }
        protected getIdProperty() { return CsDocTypeRow.idProperty; }
        protected getLocalTextPrefix() { return CsDocTypeRow.localTextPrefix; }
        protected getNameProperty() { return CsDocTypeRow.nameProperty; }
        protected getService() { return CsDocTypeService.baseUrl; }
        // protected getDeletePermission() { return CsDocTypeRow.deletePermission; }
        protected getInsertPermission() { return CsDocTypeRow.insertPermission; }
        protected getUpdatePermission() { return CsDocTypeRow.updatePermission; }

        protected form = new CsDocTypeForm(this.idPrefix);

    }
}